// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"15c1a852","128":"63f3fe62","275":"b84bead7","453":"269526f2","507":"792730a1","661":"e3352f34","678":"4b89f1ea","722":"972a9cb0","930":"54736d10"}[chunkId] + ".chunk.js";
};